import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {HiperioRegistrationConfig} from "../../../shared/interface/hiperio-registration-config";

@Component({
  selector: 'app-hiperio-registration-config-details',
  templateUrl: './hiperio-registration-config-details.component.html',
  styleUrls: ['./hiperio-registration-config-details.component.scss']
})
export class HiperioRegistrationConfigDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  hiperioRegistrationConfigId: string;
  hiperioRegistrationConfigObject?: HiperioRegistrationConfig;
  hiperioRegistrationConfig: ReplaySubject<HiperioRegistrationConfig> = new ReplaySubject<HiperioRegistrationConfig>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.hiperioRegistrationConfigId = params.id;
        this.loadHiperioRegistrationConfig();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadHiperioRegistrationConfig(): void {
    this.agentsProfileHiperioService.getHiperioRegistrationConfig(this.hiperioRegistrationConfigId).subscribe((hiperioRegistrationConfig: HiperioRegistrationConfig) => {
      this.hiperioRegistrationConfig.next(hiperioRegistrationConfig);
      this.hiperioRegistrationConfigObject = hiperioRegistrationConfig;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
